module.exports = __webpack_public_path__ + "static/media/B_fresh_navy.1d2e5644.png";